export default __webpack_public_path__ + "static/media/hmmglob.d281b990.jpeg";